<template>
	<button
		is="sui-button"
		:disabled="loading || disabled"
		:class="[
			$style.button,
			$style[styleButton],
			loading ? 'loading' : '',
			styleClass
		]"
		v-on="$listeners"
	>
		<slot />
	</button>
</template>

<script>
export default {
	props: {
		styleButton: {
			type: String,
			default: ''
		},
		styleClass: {
			type: String,
			default: ''
		},
		loading: {
			type: Boolean,
			default: false
		},
		disabled: {
			type: Boolean,
			default: false
		}
	}
};
</script>

<style lang="scss" module>
@import '@design';

.button {
	@extend %typography-small;

	padding: $size-button-padding;
	font-family: $montserrat-bold !important;
	font-weight: 900;
	color: $color-button-text;
	cursor: pointer;
	border: none;

	&:disabled {
		cursor: not-allowed;
		background: $color-button-disabled-bg;
	}
}

.primary {
	color: $color-text-white !important;
	background-color: $background-primary !important;
	box-shadow: 0 0 0 1px #1b396a inset !important;
	i {
		color: $color-text-white !important;
	}
	&:disabled {
		cursor: not-allowed;
		background: $background-primary-disabled;
	}
	&:hover {
		background: $background-primary-disabled;
	}
}

.success {
	color: $color-text-white !important;
	background-color: $background-success !important;
	i {
		color: $color-text-white !important;
	}
	&:disabled {
		cursor: not-allowed;
		background: $background-success-disabled;
	}
	&:hover {
		background: $background-success-hover;
	}
}

.danger {
	color: $color-text-white !important;
	background-color: $background-danger !important;
	i {
		color: $color-text-white !important;
	}
	&:disabled {
		cursor: not-allowed;
		background: $background-danger-disabled;
	}
	&:hover {
		background: $background-danger-hover;
	}
}

.warning {
	color: $color-text-white !important;
	background-color: $background-warning !important;

	i {
		color: $color-text-white !important;
	}
	&:disabled {
		cursor: not-allowed;
		background: $background-warning-disabled;
	}
	&:hover {
		background: $background-warning-hover;
	}
}
</style>
